import React from "react";
import styles from "./BasicInfoLocationManagement.module.css";
import { SubmitButton, TextComponent } from "../../../../../components";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";
import { useNavigate } from "react-router-dom";

const BasicInfoLocationManagement = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.mainCont}>
      <div className={styles.subCont}>
        <div className={styles.leftCont}>
          <div className={styles.Box}>
            <TextComponent className={styles.smallHeading} text="Bakery Name" />
            <TextComponent text="Archway Cookies" color={"#8391A1"} />
          </div>
          <div className={styles.Box}>
            <TextComponent
              className={styles.smallHeading}
              text="Business Email"
            />
            <TextComponent text="paula611@gmail.com" color={"#8391A1"} />
          </div>
          <div className={styles.Box}>
            <TextComponent className={styles.smallHeading} text="Location" />
            <TextComponent
              text="2614 Sweetwood Drive, Arvada, CO 80002"
              color={"#8391A1"}
            />
          </div>
          <div className={styles.Box}>
            <TextComponent
              className={styles.smallHeading}
              text="Specialties Offered"
            />
            <TextComponent text="Bread, cake" color={"#8391A1"} />
          </div>
        </div>
        <div className={styles.rightCont}>
          <div className={styles.Box}>
            <TextComponent
              className={styles.smallHeading}
              text="Business Phone Number"
            />
            <TextComponent text="(785) 712-6532" color={"#8391A1"} />
          </div>
          <div className={styles.Box}>
            <TextComponent
              className={styles.smallHeading}
              text="Primary Business Address"
            />
            <TextComponent
              text="1949 Linda Street, West Brunswick Twp, PA 19549"
              color={"#8391A1"}
            />
          </div>
          <div className={styles.Box}>
            <TextComponent
              className={styles.smallHeading}
              text="Business Type"
            />
            <TextComponent text="Artisan" color={"#8391A1"} />
          </div>
          <div className={styles.Box}>
            {/* <HeadingComponent
              fontSize={"var(--subheading)"}
              className={styles.smallHeading}
            /> */}
              <TextComponent
              className={styles.smallHeading}
              text="Emergency Contact"
            />
            <SubmitButton
              onClick={() => navigate("/AdminEmergencyContactDetails")}
              title={"View Contact List "}
              btnContainerClass={styles.btnContainer}
              primary
              btnClass={`${styles.btn}`}
            />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoLocationManagement;
